var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 55,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.3 0h40v40h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083d9c",
    fillRule: "evenodd",
    stroke: "#083d9c",
    strokeWidth: 0.3,
    d: "M23.8 28.4s.9-.7 1.8-.7 1 .6 1.7.6 1.1-.6 1.9-.6 1.7.5 1.7.5l-3.3 1zm-2-1h11.4s-1-1-2.2-1.1c-1.1 0-.8.5-1.7.6s-1-.6-1.9-.6-1.3.6-1.9.6-1.4-.6-1.8-.6-2.1.7-2.1.7l.3.3ZM20.5 26h14c.2-.3-.7-1-1.6-1.1-.6 0-1.1.7-1.7.7s-1.2-.7-1.8-.7-1.3.7-2 .7-1-.7-1.9-.7-1.1.8-1.7.7c-.7 0-1.2-.7-1.8-.7s-1.5.8-1.7.8.2.4.2.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "m25.8 18.2 3.2.9v-4.6c-1.5.1-2.7-2.8-.1-3-2.6-.3-2.9.3-3.1 1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083d9c",
    fillRule: "evenodd",
    d: "M23.8 21.6H31Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#083d9c",
    strokeLinecap: "round",
    strokeWidth: 0.6,
    d: "M23.8 21.6H31"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "m24 19.8 1 1.2m-1 0 1-1.1m-.4-.1v.7m.9-.7.8 1.2m-.8 0 .9-1.1m-.4-.1v.7m.9-.7.8 1.2m-.8 0 .9-1.1m-.5-.1v.7m1-.7L29 21m-.8 0 1-1.1m-.5-.1v.7m.9-.7.8 1.2m-.8 0 1-1.1m-.5-.1v.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d08",
    fillRule: "evenodd",
    d: "M18.9 21.6h3v-1.9l-3.4-.1zm-.2-2.6 3.3.3v-1.4l-3.2-1.2zm.7-2.8 2.5 1.3.4-.4q-.2 0-.2-.3l.2-.4q-.2 0-.3-.3l.2-.3-2.2-2zM36 21.7h-3.2v-2l3.5-.2zm-3.2-2.4 3.8-.4-.8-2.3-3 1.3zm2.8-3.3-2.8 1.5q0-.3-.3-.4l.2-.3-.2-.3.2-.4-.2-.4 2.2-1.7zm-6 3.3H31v-.6zm-4.3 0h-1.4v-.7zm0-.2-1.4-.8v-1l-.2-.1c0-.4 1 .7 1.6 1.1zm4.3-.1v-.6l1.6-1.5-.2.5v1zM21 13.7l1.5 1.6q.1-.2.7-.2t.6.3l-.1.3.2.4-.2.4.2.1 1.4 1.3v-1.4L22.4 12zm2.3-1.7 2 4s0-3.7.3-4l-.6-1zm8.4.1L29.5 16v-1.7q.1-.1-.1-.2h-.7l.9-3zm2.2 1.7-1.4 1.4h-1q-.4 0-.4.2c0 .3.2 0 .2.3l-.2.4q.2.2.1.3L29.5 18v-1.5l3-4.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M26.5 22.4c-.7 1.1-2.6.8-3 0v-5l-.3-.2.3-.4-.3-.3.3-.4q-.1-.2-.4-.3l.4-.3h-.8c-.4 0 0 0 0 .3l-.2.3q0 .3.3.4l-.3.3.2.4-.3.3v5c.5 2.5 3.3 3.1 4-.1Zm1.8 0c.7 1.1 2.6.8 3 0v-5l.3-.2-.3-.4.3-.3-.3-.4.3-.3-.2-.3h.7c.4 0 0 0 0 .3l.2.3q0 .3-.3.4l.3.3-.2.4.3.3v5c-.5 2.5-3.3 3.1-4-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083d9c",
    fillRule: "evenodd",
    stroke: "#083d9c",
    strokeWidth: 0.3,
    d: "M25.8 24.6H29s-.7-1-1.5-1c-1 0-1.6 1-1.6 1Zm10 0h-4.3l.7-.7q.1.3.7.4c.6 0 1-.7 1.6-.6.5 0 1.2.9 1.2.9Zm-16.8 0h4.2l-.7-.7c-.3.2-.2.3-.7.4-.6 0-1.1-.7-1.6-.6s-1.2.9-1.2.9Zm.3-1.4h3l-.2-.9c-.8-.2-1.4.6-2 .6-.5 0-1.1-.6-1.1-.6zm16.2 0h-3l.1-.9c.8-.2 1.5.6 2 .6s1.2-.6 1.2-.6zm-9 0h1.6s0-.5-.8-.5-.7.6-.7.6Zm-.8-.6.6-.6h-1l-.7.6zm3.4 0q-.5-.2-.7-.6h1l.7.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    d: "M-2.7 30h60v10h-60zm0-30h60v10h-60z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPf);
export default __webpack_public_path__ + "static/media/pf.8064b68862e2dda19d24259e93a7c23a.svg";
export { ForwardRef as ReactComponent };